import type { SerializedEditorState, SerializedLexicalNode } from 'lexical';

function extractNodeText(node: SerializedLexicalNode): string {
    if (node.type === 'linebreak') {
        return '\n';
    }
    if ('text' in node && typeof node.text === 'string') {
        return node.text;
    }
    if ('children' in node && Array.isArray(node.children)) {
        return node.children.map(extractNodeText).join('');
    }
    return '';
}

/** First line is the task's title; the further lines collapse into one detail line. */
export function deriveTaskText(descriptionRich: SerializedEditorState | null): {
    title: string;
    detail: string;
} {
    const lines =
        descriptionRich?.root.children
            .flatMap((paragraph) => extractNodeText(paragraph).split('\n'))
            .map((line) => line.trim())
            .filter(Boolean) ?? [];

    const [titleLine, ...detailLines] = lines;

    return { title: titleLine ?? '', detail: detailLines.join(' · ') };
}
